import {SerializedStyles} from '@emotion/react';
import {css, useTheme} from '@mui/material';
import * as React from 'react';
import {GetStylesFunction} from 'src/js/common/types';

import {useDefaultScrollTo} from '../hooks';

interface OwnProps {
  isOverflow?: boolean;
  inputCss?: SerializedStyles;
  noTopPadding?: boolean;
  defaultScroll?: number;
  onScroll?: (event: React.UIEvent<HTMLElement>) => void;
}

type Props = OwnProps;

export const DlMuiComponentBox: React.FC<Props> = (props) => {
  const {children, isOverflow = true, noTopPadding = false, inputCss, defaultScroll, onScroll} = props;

  const theme = useTheme();
  const styles = getStyles({
    theme,
    params: {isOverflow, inputCss, noTopPadding},
  });

  const scrollRef = useDefaultScrollTo(defaultScroll);

  return (
    <div data-name={'dl-mui-component-box--content-wrapper'} css={styles.contentWrapper} ref={scrollRef} onScroll={onScroll}>
      {children}
    </div>
  );
};

DlMuiComponentBox.displayName = 'DlMuiComponentBox';

const getStyles: GetStylesFunction = (options) => ({
  contentWrapper: css(
    {
      display: 'flex',
      flexDirection: 'column',
      flex: '1 1 auto',
      paddingTop: `${options?.params?.noTopPadding ? '0px' : '12px'}`,
      height: 'calc(100% - (var(--dlSelectedFiltersContainerHeight) + var(--dlSelectedFiltersContainerMarginBottom)))',
      width: '100%',
      overflow: `${options?.params?.isOverflow ? 'auto' : 'unset'}`,
      gap: `${options?.theme?.spacing(2)}`,
    },
    options?.params?.inputCss
  ),
});
